<!--  -->
<template>
  <div>

        <section class="category-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-9">
                    <div class="section-heading">
                      <div class="section__divider"></div>
                        <h2 class="section__title">直播中心</h2>
                    </div><!-- end section-heading -->
                </div><!-- end col-lg-9 -->
                <div class="col-lg-3">
                    <div class="button-shared h-100 d-flex align-items-center justify-content-end">
                        <router-link class="theme-btn" to="/liveview">所有直播<i class="el-icon-arrow-right"></i></router-link>
                    </div><!-- end button-shared-->
                </div><!-- end col-lg-3 -->
            </div><!-- end row -->
            <div class="row category-wrapper" v-if="lives&&lives.length>0">
              <div class="col-lg-3" v-for="(live,index) in lives" :key="index" >
                  <div class="category-item">
                      <img :src="live.picsrc?`${global.remoteIp}/uploads/${live.picsrc}`:'/static/images/mor.jpg'" alt="">
                      <div class="course-tooltip">
                        <span class="tooltip-label">{{dateFormat(new Date(live.time),"yyyy-MM-dd hh:mm")}}</span>
                      </div>
                      <div class="category-content">
                          <span class="cat__title"><router-link :to="`/mylive/${live._id}`">{{live.title}}</router-link></span>
                          <span class="cat__meta_right"> <router-link :to="`/mylive/${live._id}`" class="read-more" style="live.state=='1'?'color: #62C485;':''">{{live.state=='1'?'已开播':'未开播'}}</router-link></span>
                      </div>
                  </div>
              </div>
            </div>
            <el-card  v-else  class="box-card">
                <el-empty description="暂无相关直播"></el-empty>
            </el-card>
        </div><!-- end container -->
    </section><!-- end category-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      lives: [],
      global,
    };
  },

  components: {},

  computed: {},

  mounted() {

    this.$axios
      .get("/api/livings?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.lives = res.data.data;
          this.intTotal = res.data.total;
        }
      });
  },

  methods: {
     dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
  },
};
</script>
<style scoped>

a:not([href]):not([tabindex]) {
    color: initial !important;
}

.category-item{
/* width: 294px;
height: 212px; */
border-radius: 5px;
border:none;
height: auto;
}
.category-item img{
width: 100%;
height: 212px;
border-radius: 5px;
}
.course-tooltip {
    /* height: 25px; */
       position: absolute;
        top: 197px;
    right: 7px;
    background: #0000006b;
    border-radius: 10px 0px 0px 0px;
    height: 25px;
    padding: 2px;
    
}
.tooltip-label{
  font-size: 12px;
    color: #FFFFFF;
}
.cat__title {
  width: 200  px;
height: 14px;
font-size: 14px;
font-weight: 600;
color: #313F57;
text-align: left;
}
.cat__title a{
  color: #313F57;
}

.category-content{
  margin-top: 17px;
}
.cat__meta_right{
      float: right;
      line-height:23px;
      width: auto;
}
.cat__meta_right a{
  color: #313F57;
      width: 41px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F68A03;
   
}
.category-item{
      width: 300px;
      padding: 10px;
}
.col-lg-3{
  padding-left: 10px;
  padding-right:10px;
}
</style>
